import(/* webpackMode: "eager", webpackExports: ["EditorLayoutClient"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/app/[lang]/(editor)/EditorLayoutClient.tsx");
;
import(/* webpackMode: "eager" */ "/home/jenkins/workspace/prod/deploy-frontend/src/app/[lang]/(editor)/styles.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/hocs/TranslationsProvider/TranslationsProvider.js");
